import api from "@/lib/api";

const KEY = "lidlink-vid";

export function getVisitorId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (window.crypto?.randomUUID?.() || `${Date.now()}${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
}

export function track(event) {
  try {
    api.post("/track", { session_id: getVisitorId(), event }).catch(() => {});
  } catch {
    /* ignore */
  }
}
